<template>
  <rich-row class="row-item" space="9">
    <rich-col span="9" class="col-item" v-for="(opt, optIndex) in curOptions" :key="'opt' + optIndex">
      <rich-select
        v-model="opt.val"
        :placeholder="opt.placeholder"
        :options="opt.options"
        @change="changeValue(opt)"
      >
      </rich-select>
    </rich-col>
    <rich-col span="6" class="col-item suffix">,000 {{ currency }}</rich-col>
  </rich-row>
</template>

<script type="text/ecmascript-6">
import { cloneDeep } from 'lodash-es'
import { getBDCountry } from '@/common/utils/i18n'
import { getCurrencyTypeByCountry } from '@didi/elvish-lib-javascript'
export default {
  name: 'StartUpCost',
  components: {
  },
  inject: ['rootForm'],
  data () {
    return {
      curOptions: cloneDeep(this.options)
    }
  },
  props: {
    value: {
      required: true,
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    currency: function () {
      return getCurrencyTypeByCountry(getBDCountry())
    }
  },
  watch: {
    value: {
      handler (nVal, oVal) {
        this.curOptions.forEach(opt => {
          opt.val = this.getValue(opt, nVal)
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeValue (opt) {
      let n = 0
      this.curOptions.forEach(opt => {
        n += opt.base * (opt.val || 0)
      })
      this.$emit('input', n.toString())
    },
    getValue (opt, nVal) {
      if (nVal === '') return
      const newValStr = (nVal / 1000).toString()
      const newValArr = newValStr.split('')
      // 如果newVal长度只有1位说明 只有千位有值 或者 千位万位都是0
      // 否则就是千万位都不为0 或者万位为0
      if (newValArr.length === 1) {
        return +newValArr[0] === 0 ? '0' : (opt.base === 10000 ? '0' : newValArr[0])
      } else {
        const thousNum = newValStr.substring(newValArr.length - 1) // 千位
        const myriadNum = newValStr.substring(0, newValArr.length - 1) // 万位
        return opt.base === 10000 ? myriadNum : thousNum
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .suffix{
    transform: translateY(80%)
  }
</style>
